import React from 'react';
import { Container } from 'react-bootstrap';
import './About.css';

const About = () => {
  return (
    <div className="about-page">
      <Container fluid className="about-container">
        <h1 className="about-title">About Us</h1>

        <div className="about-card">
          <h2 className="about-card-heading">Freakers Family Welcomes You !</h2>
          <p className="about-card-text">
            Freakers blend modern trends with timeless style, crafting clothing that feels fresh yet
            effortlessly classic. With unique fabrics, refined details, and thoughtfully made
            collections, Freakers gives you pieces that stand out quietly but confidently—style you
            can wear every day, and remember for its originality.
          </p>
        </div>
      </Container>
    </div>
  );
};

export default About;
